// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1c44X","savePackageButton":"ClientWallet_savePackageButton__EYoSc"};